import { createColumnHelper } from "@tanstack/react-table";
import {
  EditActionButton,
  PrintActionButton,
} from "../../../../../../components/common/primebmd-ui/EditActionButton";
import { IEJOColumnsApproval } from "../../../utils/types";
import { useSnackBar } from "../../../../../../components/ToastProvider";

export const useCreateEJOPendingApprovalColumns = () => {
  const { showSnackBar } = useSnackBar();
  const columnHelper = createColumnHelper<IEJOColumnsApproval>();

  const ejoPendingApprovalColumns = [
    columnHelper.accessor("ejoNumber", {
      id: "ejoNumber",
      header: "MRRF No.",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("equipmentNo", {
      id: "equipmentNo",
      header: "Equipment No.",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("projectLocation", {
      id: "projectLocation",
      header: "Project / Location",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("daysElapsed", {
      id: "daysElapsed",
      header: "Days Elapsed",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.display({
      id: "actions",
      header: "Action",
      cell: ({ row }) => (
        <>
          <EditActionButton route={`edit/${row.original.id}`} />
          <PrintActionButton
            onClick={() => {
              showSnackBar("PDF Preview started", "success");
              const url = `${process.env.REACT_APP_API_URL}ejo/pdf/${row.original.id}`;
              window.open(url, "_blank");
            }}
          />
        </>
      ),
      enableHiding: false,
    }),
  ];

  return ejoPendingApprovalColumns;
};
